import { render, staticRenderFns } from "./ListAdmissions.vue?vue&type=template&id=65e75c8e"
import script from "./ListAdmissions.vue?vue&type=script&lang=js"
export * from "./ListAdmissions.vue?vue&type=script&lang=js"
import style0 from "./ListAdmissions.vue?vue&type=style&index=0&id=65e75c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports